<template>
	<my-dialog title="个人信息" dialogType="form" :visible.sync="showDialog" :close-on-click-modal="false"
		@close="closeDialog">
		<div>
			<el-form label-width="8.75rem" :model="editForm" :rules="rules" ref="editForm" class="demo-form-inline"
				inline>
				<el-form-item label="姓名" prop="chName">
					<el-input disabled class="input_200px" size="small" v-model="editForm.chName">
					</el-input>
				</el-form-item>
				<el-form-item label="用户名" prop="userName">
					<el-input disabled class="input_200px" size="small" v-model="editForm.userName">
					</el-input>
				</el-form-item>
				<el-form-item label="照片" prop="userImagePath">
					<el-upload v-if="showImg.photo === ''" class="input_200px" :headers="headers" :data="editPhoto"
						ref="upload" :multiple="false" :action="action2" :on-success="progress" :limit="1"
						list-type="picture-card" :auto-upload="true" :show-file-list="false">
						<i slot="default" class="el-icon-plus"></i>
					</el-upload>
					<div v-else class="input_200px">
						<div class="up_img">
							<img class="up_img" :src="showImg.photo" />
							<i class="el-icon-delete ui_delete" @click="deleteImg(1)"></i>
						</div>
					</div>
				</el-form-item>
				<el-form-item label="签名" prop="signImg">
					<el-upload v-if="showImg.sign === ''" class="input_200px" :headers="headers" :data="editPhoto"
						ref="upload" :multiple="false" :action="action1" :on-success="progress" :limit="1"
						list-type="picture-card" :auto-upload="true" :show-file-list="false">
						<i slot="default" class="el-icon-plus"></i>
					</el-upload>
					<div v-else class="input_200px">
						<div class="up_img">
							<img class="up_img" :src="showImg.sign" />
							<i class="el-icon-delete ui_delete" @click="deleteImg(2)"></i>
						</div>
					</div>
				</el-form-item>
				<el-form-item label="性别" prop="gender">
					<el-radio-group disabled v-model="editForm.gender" class="input_200px">
						<el-radio-button :label="1">男</el-radio-button>
						<el-radio-button :label="0">女</el-radio-button>
					</el-radio-group>
				</el-form-item>
				<el-form-item label="工号" prop="workerNo">
					<el-input disabled class="input_200px" size="small" v-model="editForm.workerNo">
					</el-input>
				</el-form-item>
				<el-form-item label="卡号" prop="cardNo">
					<el-input disabled class="input_200px" size="small" v-model="editForm.cardNo">
					</el-input>
				</el-form-item>
				<el-form-item label="身份证号" prop="idCardNo">
					<el-input disabled class="input_200px" size="small" v-model="editForm.idCardNo">
					</el-input>
				</el-form-item>
				<el-form-item label="部门" prop="deptCode">
					<el-input disabled class="input_200px" size="small" v-model="editForm.dept">
					</el-input>
				</el-form-item>
				<el-form-item label="角色" prop="roleId">
					<el-input disabled class="input_200px" size="small" v-model="editForm.roleName">
					</el-input>
				</el-form-item>
				<el-form-item label="人员职级" prop="userRank">
					<el-input disabled class="input_200px" size="small" v-model="editForm.userRank">
					</el-input>
				</el-form-item>
				<el-form-item label="人员类别" prop="userType">
					<el-select disabled size="small" v-model="editForm.userType" filterable :clearable="true"
						class="input_200px">
						<el-option v-for="(item) in userTypeList" :key="item.dicCode" :label="item.dicText"
							:value="item.dicCode">
						</el-option>
					</el-select>
				</el-form-item>
				<el-form-item label="联系方式" prop="phone">
					<el-input class="input_200px" size="small" v-model="editForm.phone">
					</el-input>
				</el-form-item>
				<el-form-item label="备注" prop="comment">
					<el-input disabled :rows="4" class="input_200px" type="textarea" v-model="editForm.comment">
					</el-input>
				</el-form-item>
			</el-form>
		</div>
		<div slot="footer" class="dialog-footer">
			<el-button size="small" @click="closeDialog">取消</el-button>
			<el-button size="small" type="primary" :loading="saveloading" class="title" @click="submitForm('editForm')">
				保存
			</el-button>
		</div>
	</my-dialog>
</template>
<script>
	import {
		GetUserInfoDetail,
		UpdateUserPhone
	} from '../../../api/userApi.js';
	import {
		GetDicDataListByParentCode
	} from '../../../api/dicDataApi.js';
	export default {
		props: [],
		data() {
			return {
				showDialog: false,
				saveloading: false,
				editForm: {},
				rules: {},
				userTypeList: [],
				hideUpload: false,
				limitCount: 1,
				headers: {
					"Authorization": 'Bearer ' + localStorage.getItem('logintoken'),
				},
				action1: '/api/sysConfig/User/UpdateUserSignature',
				action2: '/api/sysConfig/User/UpdateUserPhoto',
				// 签名、人员照片
				editPhoto: {
					KeyId: '',
				},

				showImg: {
					photo: '',
					sign: ''
				}
			};
		},
		computed: {},
		watch: {},
		components: {},
		created() {},
		methods: {
			// 显示
			showUserInfoDialog(data) {
				this.editPhoto.KeyId = data.keyId;
				this.getUserType();
				this.getUserInfoDetail();
			},

			// 点击保存
			submitForm(editData) {
				this.$refs[editData].validate((valid) => {
					if (valid) {
						this.updateUserPhone();
					} else {
						return false;
					}
				});
			},


			// 删除图片
			deleteImg(type) {
				if (type === 1) {
					this.showImg.photo = '';
				} else {
					this.showImg.sign = '';
				}
			},

			// 获取个人信息详情
			getUserInfoDetail() {
				let parameter = {
					keyId: this.editPhoto.KeyId,
				};
				GetUserInfoDetail(parameter)
					.then((res) => {
						if (res.code == 1) {
							this.editForm = res.data
							if (res.data.photoImg === '') {
								this.showImg.photo = '';
							} else {
								this.showImg.photo = 'data:image/png;base64,' + res.data.photoImg;
							}
							if (res.data.signImg === '') {
								this.showImg.sign = '';
							} else {
								this.showImg.sign = 'data:image/png;base64,' + res.data.signImg;
							}
							this.showDialog = true;
						} else {
							this.$message.error(res.msg);
						}
					})
					.catch((err) => {
						this.loading = false;
						this.$message.error('加载失败，请稍后再试！');
					});

			},

			// 获取人员类型
			getUserType() {
				let parmter = {
					parentCode: "UserType",
				};
				GetDicDataListByParentCode(parmter)
					.then((res) => {
						if (res.code == 1) {
							this.userTypeList = res.data;
						} else {
							this.$message.error(res.msg);
						}
					})
					.catch((err) => {
						this.$message.error("加载失败，请稍后再试！");
					});
			},


			// 更新电话号码
			updateUserPhone() {
				this.saveloading = true;
				let param = {
					keyId: this.editForm.keyId,
					phone: this.editForm.phone
				}
				UpdateUserPhone(param)
					.then((res) => {
						this.saveloading = false;
						if (res.code == 1) {
							this.$message({
								type: 'success',
								message: '保存成功！',
							});
							this.showDialog = false;
						} else {
							this.$message({
								type: 'info',
								message: res.msg,
							});
						}
					})
					.catch((err) => {
						this.saveloading = false;
						this.$message.error('保存失败，请稍后再试！');
					});
			},

			progress(event, file) {
				this.getUserInfoDetail();
			},

			// 关闭
			closeDialog() {
				this.showDialog = false
			},

		},
	}
</script>
<style scoped lang="scss">
	.up_img {
		width: 100px;
		height: 100px;
		position: relative;

		.ui_delete {
			position: absolute;
			font-size: 20px;
			color: #ff0000;
			top: 0px;
			right: 0px;
		}
	}

	::v-deep .el-upload--picture-card {
		width: 100px;
		height: 100px;
		line-height: 100px;
	}

	::v-deep .el-input.is-disabled .el-input__inner {
		background: none;
	}

	::v-deep .el-textarea.is-disabled .el-textarea__inner {
		background: none;
	}
	
	::v-deep .el-input__inner {
		background: #ffffff;
		color: #606266;
		border: 0.0625rem solid #cfcfcf;
	}
</style>